(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yd-announcement"]) return;
  try {
    
class YDAnnouncement extends HTMLElement {
 connectedCallback() {
  this.abort?.abort();
  this.observer?.disconnect();
  this.abort=new AbortController();
  const signal=this.abort.signal;
  const passive={signal,passive:true};
  this.source=this.querySelector('[data-ticker-source]');
  this.messages=[...this.source.querySelectorAll('[data-message]:not([data-copy])')];
  this.track=this.querySelector('.yd-ticker-track');
  this.viewport=this.querySelector('.yd-ticker-window');
  this.status=this.querySelector('[data-announcement-status]');
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.contacts=new Set();
  this.hovered=false;
  this.focusPaused=false;
  this.paused=false;
  this.measuredWidth=0;
  this.pointerInput=false;
  document.addEventListener('pointerdown',()=>{this.pointerInput=true;}, {...passive,capture:true});
  document.addEventListener('keydown',()=>{this.pointerInput=false;}, {signal,capture:true});
  const hover=event=>{
   if(event.pointerType==='mouse') {this.hovered=true;this.updatePause();}
  };
  this.addEventListener('pointerenter',hover,passive);
  this.addEventListener('pointermove',hover,passive);
  this.addEventListener('pointerleave',event=>{
   if(event.pointerType==='mouse')this.hovered=false;
   this.contacts.delete(event.pointerId);
   this.updatePause();
  },passive);
  this.addEventListener('pointerdown',event=>{
   this.focusPaused=false;
   if(event.pointerType!=='mouse') {this.hovered=false;this.contacts.add(event.pointerId);}
   this.updatePause();
  },passive);
  const release=event=>{
   this.contacts.delete(event.pointerId);
   if(event.type==='pointercancel'&&event.pointerType==='mouse')this.hovered=false;
   this.updatePause();
  };
  document.addEventListener('pointerup',release,passive);
  document.addEventListener('pointercancel',release,passive);
  this.addEventListener('lostpointercapture',release,passive);
  this.addEventListener('focus',()=>{
   this.focusPaused=!this.pointerInput;
   this.updatePause();
  },{signal});
  this.addEventListener('blur',()=>{this.focusPaused=false;this.updatePause();},{signal});
  this.addEventListener('keydown',event=>{
   if(event.target!==this||this.reduced.matches||event.repeat||event.altKey||event.ctrlKey||event.metaKey)return;
   if(event.key!=='Enter'&&event.key!==' ')return;
   event.preventDefault();
   this.paused=!this.paused;
   this.focusPaused=false;
   this.updatePause();
   this.status.textContent=this.paused?'Announcements paused. Press Enter or Space to resume.':'Automatic announcements resumed.';
  },{signal});
  const reset=()=>{this.contacts.clear();this.hovered=false;this.focusPaused=false;this.updatePause();};
  window.addEventListener('blur',reset,{signal});
  window.addEventListener('pagehide',reset,{signal});
  window.addEventListener('pageshow',reset,{signal});
  document.addEventListener('visibilitychange',reset,{signal});
  this.reduced.addEventListener('change',()=>{reset();this.build();},{signal});
  this.observer=new ResizeObserver(()=>{
   const width=this.viewport.clientWidth;
   if(Math.abs(width-this.measuredWidth)>1){this.measuredWidth=width;this.build();}
  });
  this.observer.observe(this.viewport);
  this.build();
  document.fonts.ready.then(()=>{if(this.isConnected&&!signal.aborted)this.build();});
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 build() {
  this.source.style.removeProperty('width');
  this.source.querySelectorAll('[data-copy]').forEach(node=>node.remove());
  this.track.querySelectorAll('[data-ticker-duplicate]').forEach(node=>node.remove());
  this.messages.forEach(node=>node.hidden=false);
  this.classList.toggle('is-static',this.reduced.matches);
  this.tabIndex=this.reduced.matches?-1:0;
  this.querySelector('[data-ticker-help]').hidden=this.reduced.matches;
  if(this.reduced.matches) {
   this.removeAttribute('aria-describedby');
   this.track.style.removeProperty('--ticker-duration');
   this.status.textContent='';
   this.updatePause();
   return;
  }
  this.setAttribute('aria-describedby',this.querySelector('[data-ticker-help]').id);
  const makeCopy=node=>{
   const copy=node.cloneNode(true);
   copy.setAttribute('aria-hidden','true');
   copy.setAttribute('inert','');
   copy.removeAttribute('id');
   copy.querySelectorAll('[id]').forEach(child=>child.removeAttribute('id'));
   return copy;
  };
  let rounds=0;
  while(this.source.getBoundingClientRect().width<this.viewport.clientWidth&&rounds++<12) {
   this.messages.forEach(node=>{const copy=makeCopy(node);copy.dataset.copy='';this.source.append(copy);});
  }
  const groupWidth=Math.ceil(this.source.getBoundingClientRect().width);
  this.source.style.width=groupWidth+'px';
  const clone=makeCopy(this.source);
  clone.removeAttribute('data-ticker-source');
  clone.dataset.tickerDuplicate='';
  this.track.append(clone);
  this.track.style.setProperty('--ticker-duration',(groupWidth/36)+'s');
  this.updatePause();
 }
 updatePause() {
  this.dataset.paused=String(this.paused||this.hovered||this.focusPaused||this.contacts.size>0||document.hidden||this.reduced.matches);
 }
}
if(!customElements.get('yd-announcement'))customElements.define('yd-announcement',YDAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yd-demo-notice"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yd-demo-notice')) {
    customElements.define('yd-demo-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.card = this.querySelector('.yd-demo-notice__card');
        this.playButton = this.querySelector('[data-demo-play]');
        this.nextButton = this.querySelector('[data-demo-next]');
        this.live = this.querySelector('[data-demo-live]');
        this.index ??= 0;
        this.playing = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.samples = [['Oliver','Manchester, England'],['Amelia','Edinburgh, Scotland'],['Harry','Cardiff, Wales'],['Isla','Belfast, Northern Ireland'],['Noah','York, England'],['Charlotte','Glasgow, Scotland'],['Jack','Bristol, England'],['Emily','Swansea, Wales']];
        this.playButton.addEventListener('click',()=>{this.card.hidden=false;this.setPlaying(!this.playing);this.announce();},options);
        this.nextButton.addEventListener('click',()=>this.advance(),options);
        this.querySelector('[data-demo-close]').addEventListener('click',()=>this.dismiss(),options);
        this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.contains(document.activeElement)){event.stopPropagation();this.dismiss();}},options);
        document.addEventListener('visibilitychange',()=>{if(document.hidden)this.setPlaying(false);},options);
        window.addEventListener('pagehide',()=>this.setPlaying(false),options);
        this.reduced.addEventListener('change',()=>{this.card.classList.remove('is-changing');if(this.reduced.matches)this.setPlaying(false);},options);
        document.addEventListener('product-info:loaded',()=>this.subscribeToVariant(),options);
        this.observer = new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)this.setPlaying(false);},{threshold:0});
        this.observer.observe(this);
        this.subscribeToVariant();
        this.querySelectorAll('button').forEach(button=>{button.disabled=false;});
        this.setPlaying(false);
      }
      subscribeToVariant() {
        if(this.unsubscribe || typeof subscribe!=='function' || typeof PUB_SUB_EVENTS==='undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange,event=>{
          const main = document.querySelector('product-info[id^="MainProduct-"]');
          if(!main || String(event.data?.sectionId)!==String(main.dataset.section)) return;
          const variant = event.data.variant;
          const image = this.querySelector('.yd-demo-notice__image');
          const media = variant?.featured_media;
          const source = media?.preview_image?.src || variant?.featured_image?.src || this.dataset.defaultImage;
          if(image && source) {const url=new URL(source,location.href);url.searchParams.set('width','144');image.removeAttribute('srcset');image.src=url.href;}
          const title = event.data.html?.querySelector('.product__title h1')?.textContent.trim();
          if(title)this.querySelector('[data-demo-product]').textContent=title;
        });
      }
      setPlaying(value) {
        this.playing=value;
        this.playButton.textContent=value?this.dataset.pause:this.dataset.play;
        this.playButton.setAttribute('aria-pressed',String(value));
        this.querySelector('[data-demo-state]').textContent=value?this.dataset.playing:(this.card.hidden?this.dataset.closed:this.dataset.paused);
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        this.timer=null;
        if(this.playing && this.isConnected)this.timer=setTimeout(()=>this.advance(),8000);
      }
      advance() {
        this.index=(this.index+1)%this.samples.length;
        const sample=this.samples[this.index];
        this.querySelector('[data-demo-event]').textContent=`${this.dataset.prefix} ${sample[0]} · ${sample[1]}`;
        this.card.hidden=false;
        this.card.classList.remove('is-changing');
        if(!this.reduced.matches){void this.card.offsetWidth;this.card.classList.add('is-changing');}
        this.setPlaying(this.playing);
        this.announce();
      }
      announce() {
        this.live.textContent=`DEMO — FICTIONAL PURCHASE DATA. ${this.querySelector('[data-demo-event]').textContent}. ${this.querySelector('[data-demo-product]').textContent}. ${this.querySelector('.yd-demo-notice__fiction').textContent}. ${this.querySelector('[data-demo-state]').textContent}`;
      }
      dismiss() {
        const restore=this.card.contains(document.activeElement);
        this.card.hidden=true;
        this.setPlaying(false);
        this.live.textContent=`DEMO — FICTIONAL PURCHASE DATA. ${this.dataset.closed}. ${this.dataset.paused}.`;
        if(restore)this.nextButton.focus();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.timer=null;
        this.playing=false;
        this.controller?.abort();
        this.observer?.disconnect();
        this.unsubscribe?.();
        this.unsubscribe=null;
        this.bound=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zz-backup-bf-yd-announcement-2026-10-09"]) return;
  try {
    
class YDAnnouncement extends HTMLElement {
 connectedCallback() {
  this.abort?.abort();
  this.observer?.disconnect();
  this.abort=new AbortController();
  const signal=this.abort.signal;
  const passive={signal,passive:true};
  this.source=this.querySelector('[data-ticker-source]');
  this.messages=[...this.source.querySelectorAll('[data-message]:not([data-copy])')];
  this.track=this.querySelector('.yd-ticker-track');
  this.viewport=this.querySelector('.yd-ticker-window');
  this.status=this.querySelector('[data-announcement-status]');
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.contacts=new Set();
  this.hovered=false;
  this.focusPaused=false;
  this.paused=false;
  this.measuredWidth=0;
  this.pointerInput=false;
  document.addEventListener('pointerdown',()=>{this.pointerInput=true;}, {...passive,capture:true});
  document.addEventListener('keydown',()=>{this.pointerInput=false;}, {signal,capture:true});
  const hover=event=>{
   if(event.pointerType==='mouse') {this.hovered=true;this.updatePause();}
  };
  this.addEventListener('pointerenter',hover,passive);
  this.addEventListener('pointermove',hover,passive);
  this.addEventListener('pointerleave',event=>{
   if(event.pointerType==='mouse')this.hovered=false;
   this.contacts.delete(event.pointerId);
   this.updatePause();
  },passive);
  this.addEventListener('pointerdown',event=>{
   this.focusPaused=false;
   if(event.pointerType!=='mouse') {this.hovered=false;this.contacts.add(event.pointerId);}
   this.updatePause();
  },passive);
  const release=event=>{
   this.contacts.delete(event.pointerId);
   if(event.type==='pointercancel'&&event.pointerType==='mouse')this.hovered=false;
   this.updatePause();
  };
  document.addEventListener('pointerup',release,passive);
  document.addEventListener('pointercancel',release,passive);
  this.addEventListener('lostpointercapture',release,passive);
  this.addEventListener('focus',()=>{
   this.focusPaused=!this.pointerInput;
   this.updatePause();
  },{signal});
  this.addEventListener('blur',()=>{this.focusPaused=false;this.updatePause();},{signal});
  this.addEventListener('keydown',event=>{
   if(event.target!==this||this.reduced.matches||event.repeat||event.altKey||event.ctrlKey||event.metaKey)return;
   if(event.key!=='Enter'&&event.key!==' ')return;
   event.preventDefault();
   this.paused=!this.paused;
   this.focusPaused=false;
   this.updatePause();
   this.status.textContent=this.paused?'Announcements paused. Press Enter or Space to resume.':'Automatic announcements resumed.';
  },{signal});
  const reset=()=>{this.contacts.clear();this.hovered=false;this.focusPaused=false;this.updatePause();};
  window.addEventListener('blur',reset,{signal});
  window.addEventListener('pagehide',reset,{signal});
  window.addEventListener('pageshow',reset,{signal});
  document.addEventListener('visibilitychange',reset,{signal});
  this.reduced.addEventListener('change',()=>{reset();this.build();},{signal});
  this.observer=new ResizeObserver(()=>{
   const width=this.viewport.clientWidth;
   if(Math.abs(width-this.measuredWidth)>1){this.measuredWidth=width;this.build();}
  });
  this.observer.observe(this.viewport);
  this.build();
  document.fonts.ready.then(()=>{if(this.isConnected&&!signal.aborted)this.build();});
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 build() {
  this.source.style.removeProperty('width');
  this.source.querySelectorAll('[data-copy]').forEach(node=>node.remove());
  this.track.querySelectorAll('[data-ticker-duplicate]').forEach(node=>node.remove());
  this.messages.forEach(node=>node.hidden=false);
  this.classList.toggle('is-static',this.reduced.matches);
  this.tabIndex=this.reduced.matches?-1:0;
  this.querySelector('[data-ticker-help]').hidden=this.reduced.matches;
  if(this.reduced.matches) {
   this.removeAttribute('aria-describedby');
   this.track.style.removeProperty('--ticker-duration');
   this.status.textContent='';
   this.updatePause();
   return;
  }
  this.setAttribute('aria-describedby',this.querySelector('[data-ticker-help]').id);
  const makeCopy=node=>{
   const copy=node.cloneNode(true);
   copy.setAttribute('aria-hidden','true');
   copy.setAttribute('inert','');
   copy.removeAttribute('id');
   copy.querySelectorAll('[id]').forEach(child=>child.removeAttribute('id'));
   return copy;
  };
  let rounds=0;
  while(this.source.getBoundingClientRect().width<this.viewport.clientWidth&&rounds++<12) {
   this.messages.forEach(node=>{const copy=makeCopy(node);copy.dataset.copy='';this.source.append(copy);});
  }
  const groupWidth=Math.ceil(this.source.getBoundingClientRect().width);
  this.source.style.width=groupWidth+'px';
  const clone=makeCopy(this.source);
  clone.removeAttribute('data-ticker-source');
  clone.dataset.tickerDuplicate='';
  this.track.append(clone);
  this.track.style.setProperty('--ticker-duration',(groupWidth/36)+'s');
  this.updatePause();
 }
 updatePause() {
  this.dataset.paused=String(this.paused||this.hovered||this.focusPaused||this.contacts.size>0||document.hidden||this.reduced.matches);
 }
}
if(!customElements.get('yd-announcement'))customElements.define('yd-announcement',YDAnnouncement);

  } catch(e) { console.error(e); }
})();
})();
